// removed by extract-text-webpack-plugin
module.exports = {"survey-details":"SurveyDetails__survey-details___32Q92","survey-instructions":"SurveyDetails__survey-instructions___oN828"};